<template>
    <div id="erproot">

        <vs-popup title="Adicionar Conexões" :active.sync="addInstancePopupActive" class="sizePopup">
            <table-instances
              :instances="instancesAvailable"
              @saveInstancesOnCustomer="attachInstancesOnErp"
              :addInstancePopupActive="addInstancePopupActive"
            />
        </vs-popup>

        <vs-table 
            ref="table" 
            :data="listData" 
            id="tableData"
            @search="searchFilter"
            @sort="sortFilter"
            :sst="true"
            :max-items="maxPerPage"
            noDataText="Sem dados disponíveis"
            search
            style="padding-right: 5px !important;"
            >
            
            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                <div class="flex flex-wrap-reverse items-center pl-4">
                    <div
                      class="
                        p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center
                        text-lg font-medium text-base text-primary border border-solid border-primary
                      "
                      @click="openSidebarToCreate"
                    >
                      <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                      <span
                        class="ml-2 text-base text-primary"
                      >
                        Adicionar Nova
                      </span>
                    </div>
                </div>

                <div>
                    <vs-dropdown
                        vs-trigger-click
                        class="cursor-pointer mr-4"
                    >
                        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">
                                {{ currentPage * maxPerPage - (maxPerPage - 1) }} -
                                {{
                                    listData.length - currentPage * maxPerPage > 0
                                        ? currentPage * maxPerPage
                                        : listData.length
                                }} of {{ listData.length }}
                            </span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>
                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="maxPerPage=4">
                                <span>4</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="maxPerPage=10">
                                <span>10</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="maxPerPage=15">
                                <span>15</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="maxPerPage=20">
                                <span>20</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
            </div>

            <template slot="thead">
                <vs-th class="text-base" sort-key="corporate_name" style="width: 75%; padding-left: 9%;">
                    Nome
                </vs-th>
                <vs-th class="text-base" style="width: 20%;">
                    Ações
                </vs-th>
            </template>

            <template slot-scope="{data}">
                <tbody>
                    <vs-tr 
                    :data="tr" 
                    :key="tr.id"
                    :id="tr.id"
                    v-for="(tr, index) in listData.slice(previousNumberRegister, nextNumberRegister)"
                    >
                        <vs-td :data="tr.corporate_name" style="border-top-left-radius: 8px; border-bottom-left-radius: 8px; padding-left: 9%;">
                            <p class="text-left">
                                {{ tr.corporate_name }}
                            </p>
                        </vs-td>

                        <vs-td :id="tr.id" style="border-top-right-radius: 8px; border-bottom-right-radius: 8px">
                            <feather-icon
                              icon="EditIcon"
                              svgClasses="w-5 h-5 hover:text-primary stroke-current"
                              @click.stop="openSidebarToUpdate(tr)"
                            />
              
                            <feather-icon
                              icon="TrashIcon"
                              svgClasses="w-5 h-5 hover:text-danger stroke-current"
                              class="ml-2"
                              @click.stop="activeDeleteModal(tr)"
                            />
                        </vs-td>
                    </vs-tr>
                </tbody>
            </template>
        </vs-table>

        <div class="sidebar-erp">
            <vs-sidebar
            click-not-close
            position-right
            default-index="1"
            color="primary"
            class="add-new-data-sidebar items-no-padding"
            spacer
            parent="body"
            v-model="sidebarIsActive"
            >
                <div class="mt-6 mb-4 flex items-center justify-between px-6">
                    <h4>INTEGRAÇÕES <span @click="showHashCode = !showHashCode">ERP</span></h4>
                    <feather-icon
                    icon="XIcon"
                    class="cursor-pointer"
                    @click="closeSidebar"
                    />
                </div>
                <vs-divider class="mb-0"/>

                <div>
                    <vs-input
                    id="input-adjustment"
                    label="Nome da Empresa"
                    class="mt-3 ml-8 w-5/6"
                    name="nome"
                    v-model="sidebarData.corporate_name"
                    v-validate="'required'"
                    />
                </div>
                <span
                    class="text-danger text-sm ml-10"
                    v-show="errors.has('nome')"
                >
                    {{ errors.first('nome') }}
                </span>

                <div>
                    <vs-input
                    id="input-adjustment"
                    label="CNPJ"
                    class="mt-3 ml-8 w-5/6"
                    name="cnpj"
                    v-mask="'##.###.###/####-##'"
                    v-model="sidebarData.cnpj"
                    v-validate="'required'"
                    />
                </div>
                <span
                    class="text-danger text-sm ml-10"
                    v-show="errors.has('cnpj')"
                >
                    {{ errors.first('cnpj') }}
                </span>

                <div class="ml-8 mt-3 con-select w-full">
                    <label for="erp-name" class="vs-input--label">Selecione o ERP</label>
                    <div class="input-select-con">
                        <v-select
                        class="v-select-erp"
                        style="width: 24em;"
                        v-model="sidebarData.erp_id"
                        :options="erpChoices"
                        :reduce="erpChoices => erpChoices.value"
                        label="text"
                        name="erpModels"
                        />
                    </div>
                </div>
                
                <span
                    class="text-danger text-sm ml-10"
                    v-show="errors.has('erp')"
                >
                    {{ errors.first('erp') }}
                </span>

                <div v-if="sidebarData.erp_id === 1">
                    <div>
                        <vs-input
                        id="input-adjustment"
                        label="Token"
                        class="mt-3 ml-8 w-5/6"
                        name="token"
                        v-model="sidebarData.token"
                        v-validate="'required'"
                        />
                    </div>
                    <span
                    class="text-danger text-sm ml-10"
                    v-show="errors.has('token')"
                    >
                        {{ errors.first('token') }}
                    </span>

                </div>

                <div style="padding:2rem;">
                    <h3>
                        {{ context === 'update' ? 'Conexões' : 'Vincular Conexões' }}
                    </h3>
                    <span v-if="context !== 'update'">
                        <ul class="mt-3">
                            <li>
                            <vs-radio 
                                v-model="chooseConnections" 
                                vs-name="chooseConnections" 
                                vs-value="none"
                            >
                                Nenhuma Conexão
                            </vs-radio>
                            </li>
    
                            <li>
                            <vs-radio 
                                v-model="chooseConnections" 
                                vs-name="chooseConnections" 
                                vs-value="choose"
                            >
                                Escolher Conexões
                            </vs-radio>
                            </li>
                        </ul>
                    </span>
    
                    <span v-if="chooseConnections == 'choose' || context === 'update'">
                        <vs-chip
                        v-for="(instance, index) in instances"
                        @click="removeInstance(instance)"
                        closable
                        color="primary"
                        class="mt-3 mr-3"
                        style="font-size: 0.9rem;"
                        >
                            {{ instance.instance.name }}
                        </vs-chip>
      
                      <vs-chip
                        @click="addInstances"
                        closable
                        close-icon="add"
                        class="mt-3 mr-3"
                        style="font-size: 0.9rem;"
                        >
                            Adicionar Conexão
                        </vs-chip>
                    </span>
                </div>

                <div v-if="showHashCode">
                    <p>{{ sidebarData.hash_code }}</p>
                </div>
                
                <div class="flex flex-wrap items-center justify-center p-6" slot="footer">
                    <vs-button class="mr-6" @click="saveData">
                      Salvar
                    </vs-button>
                    <vs-button type="border" color="danger" @click="closeSidebar">
                      Cancelar
                    </vs-button>
                </div>

                <div>
                    <vs-popup title="Remover integração ERP" :active.sync="modalDelete" class="sizePopup">
                        <p> Deseja realmente remover a integração <strong>{{targetDelete.erp_name}}</strong> 
                            no nome de <strong>{{targetDelete.corporate_name}}</strong>?
                        </p>
                        <br>

                        <vs-checkbox v-model="deleteProducts" title="Ao clicar nessa opção todos os produtos vinculados a esse ERP serão removidos">
                            Remover produtos vinculados ao ERP
                        </vs-checkbox>
                        
                        <div class="w-full d-flex justify-content-flex-end mt-3">
                          <vs-button color="danger" @click="deleteProducts ? modalToDeleteProducts() : deleteErp()">Remover</vs-button>
                        </div>
                      </vs-popup>
                </div>

            </vs-sidebar>
        </div>

        <div class="mt-3 mr-4">
            <vs-pagination
            :total="totalPages"
            v-model="currentPage"
            max="7"
        />
        </div>
    </div>
</template>

<script>
    import ERP from '@/http/requests/erp';
    import TableInstances from '../../users/TableInstances.vue'
    import vSelect from 'vue-select'

    export default {
        name: 'erp-integration',
        data() {
            return {
                listData: [],
                sidebarIsActive: false,
                sidebarData: {
                    id: undefined,
                    corporate_name: '',
                    cnpj: '',
                    erp_id: null,
                    erp_name: '',
                    token: '',
                    callseeder: true
                },
                context: '',
                modalDelete: false,
                targetDelete: {
                    id: undefined,
                    corporate_name: '',
                    erp_id: null,
                    erp_name: '',
                },
                totalPages: 0,
                currentPage: 1,
                maxPerPage: 4,
                previousNumberRegister: 0,
                nextNumberRegister: 0,
                search: "",
                stateSort: undefined,
                instances: [],
                instancesAvailable: [],
                addInstancePopupActive: false,
                chooseConnections: '',
                instancesToRemove: [],
                availableErps: [],
                deleteProducts: false,
                showHashCode: false
            }
        },
        components: {
            TableInstances,
            vSelect
        },
        methods: {
            async loadingData() {
                await ERP.fetch()
                .then((response) => {
                    this.registerLength = response.data.data.getErp.length;   
                    this.totalPages = Math.ceil(this.registerLength/this.maxPerPage);
                    this.nextNumberRegister = this.maxPerPage;

                    return this.listData = response.data.data.getErp;
                })
                .catch((error) => {
                    console.log(error)
                    return this.$vs.notify({
                        color: 'danger',
                        title: 'Erro',
                        text: 'Houve algum erro ao carregar os dados!'
                    });
                });

                await ERP.fetchErpTenancy()
                .then((response) => {
                    this.availableErps = response.data.data.getErpTenancy
                })
                .catch((error) => {
                    console.log(error)
                    return this.$vs.notify({
                        color: 'danger',
                        title: 'Erro',
                        text: 'Houve algum erro ao carregar os dados!'
                    });
                });
                this.clearInstances();
            },
            openSidebarToCreate() {
                this.sidebarIsActive = true;

                this.sidebarData = {
                    id: undefined,
                    corporate_name: '',
                    cnpj: '',
                    erp_name: '',
                    erp_id: null,
                    token: '',
                    callseeder: true
                }
                this.context = "create";
            },
            closeSidebar() {
                this.sidebarIsActive = false;
                this.clearInstances();
            },
            async openSidebarToUpdate(tr) {
                this.sidebarIsActive = true;
                await this.getErpInstance(tr.id)

                this.sidebarData.id = tr.id;
                this.sidebarData.corporate_name = tr.corporate_name;
                this.sidebarData.cnpj = tr.cnpj;
                this.sidebarData.erp_name = tr.erp_name;
                this.sidebarData.erp_id = tr.erp_id;
                this.sidebarData.hash_code = tr.hash_code;
                const parsedAuth = JSON.parse(tr.auth);
                this.sidebarData.token = parsedAuth.bearer_token;

                this.context = "update";
            },
            saveData() {
                if (this.chooseConnections === '' && this.context === 'create') {
                    return this.$vs.notify({
                        color: 'danger',
                        title: 'Atenção!',
                        text: 'Escolha uma opção de conexão para continuar.'
                    })
                }
                else if (this.instances.length <= 0 && this.chooseConnections === 'choose' && this.context === 'create') {
                    return this.$vs.notify({
                        color: 'danger',
                        title: 'Atenção!',
                        text: 'Escolha ao menos uma conexão para continuar.'
                    })
                }

                if (this.context === 'update') {
                    this.updateErp();
                } else {
                    this.createErp();
                }
            },
            updateErp() {
                const chosenInstances = [];
                for (let index = 0; index < this.instances.length; index++) {
                    chosenInstances.push(this.instances[index].instance.id); 
                }

                const data = {
                    corporate_name: this.sidebarData.corporate_name,
                    cnpj: this.sidebarData.cnpj,
                    erp_id: this.sidebarData.erp_id,
                    token: this.sidebarData.token,
                    chosen_instances: chosenInstances,
                }
                this.$validator.validateAll().then((response) => {
                    if (!response) {
                        this.$vs.notify({
                            color: 'danger',
                            title: 'Algo deu errado:',
                            text: 'Existem campos obrigatórios não preenchidos!'
                        })
                        return;
                    }

                    if (this.instancesToRemove.length > 0) {
                        this.deleteInstances()
                    }              

                    ERP.update(this.sidebarData.id, data)
                    .then((response) => {
                        this.$vs.notify({
                            color: 'success',
                            title: 'Sucesso!',
                            text: 'Informações atualizadas com sucesso!'
                        });
                        this.closeSidebar();
                        this.sidebarData = {
                            id: undefined,
                            corporate_name: '',
                            cnpj: '',
                            erp_name: '',
                            erp_id: null,
                            token: '',
                        }
                        this.loadingData();
                    })
                    .catch((exception) => {
                        this.$vs.notify({
                            color: 'danger',
                            title: 'Ocorreu um erro ao enviar os dados!',
                            text: 'Erro ao atualizar os dados, por favor nos contate para corrigir-mos!'
                        });
                        console.log(exception);
                        this.closeSidebar();
                    });
                })
            },
            createErp() {
                const chosenInstances = [];
                for (let index = 0; index < this.instances.length; index++) {
                    chosenInstances.push(this.instances[index].instance.id); 
                }

                const data = {
                    corporate_name: this.sidebarData.corporate_name,
                    cnpj: this.sidebarData.cnpj,
                    erp_id: this.sidebarData.erp_id,
                    token: this.sidebarData.token,
                    callseeder: true,
                    chosen_instances: chosenInstances
                }

                this.$validator.validateAll().then((response) => {
                    if (!response) {
                        this.$vs.notify({
                            color: 'danger',
                            title: 'Algo deu errado:',
                            text: 'Existem campos obrigatórios não preenchidos!'
                        })
                        return;
                    } else {
                        ERP.create(data)
                        .then((response) => {
                            this.$vs.notify({
                                color: 'success',
                                title: 'Sucesso!',
                                text: 'Informações criadas com sucesso!'
                            });
                            this.closeSidebar();
                            this.sidebarData = {
                                id: undefined,
                                corporate_name: '',
                                cnpj: '',
                                erp_name: '',
                                erp_id: null,
                                token: '',
                                callseeder: true
                            }
                            this.loadingData();
                        })
                        .catch((exception) => {
                            this.$vs.notify({
                                color: 'danger',
                                title: 'Ocorreu um erro ao enviar os dados!',
                                text: 'Erro ao criar os dados, por favor nos contate para corrigir-mos!'
                            });
                            console.log(exception);
                        });
                    }
                })
                
            },
            activeDeleteModal(tr) {
                this.modalDelete = true;
                this.targetDelete = {
                    id: tr.id,
                    corporate_name: tr.corporate_name,
                    erp_name: tr.erp_name
                }
            },
            deleteErp(deleteAllProducts = false) {
                ERP.delete(this.targetDelete.id, deleteAllProducts)
                .then((response) => {
                    this.$vs.notify({
                        color: 'success',
                        title: 'Sucesso!',
                        text: 'Integração removida com sucesso!'
                    });

                    this.modalDelete = false;
                    this.targetDelete = {
                        id: undefined,
                        corporate_name: '',
                        erp_name: ''
                    }

                    this.loadingData();
                })
                .catch((exception) => {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Ocorreu um erro ao enviar os dados!',
                        text: 'Erro ao atualizar os dados, por favor nos contate para corrigir-mos!'
                    });
                    console.log(exception);
                    this.modalDelete = false;
                });
            },
            modalToDeleteProducts() {
                this.modalDelete = false;
                return this.$vs.dialog({
                    type:'confirm',
                    color: 'danger',
                    title: `Atenção!`,
                    text: 'Todos os produtos vinculados a essa ERP serão deletados',
                    accept: () => this.deleteErp(true),
                    cancel: () => this.modalDelete = true,
                    acceptText: 'Confirmar',
                    cancelText: 'Voltar'
                })
            },
            async searchFilter(searchQuery) {
                this.search = searchQuery;

                await ERP.fetchWhere(this.search)
                .then((response) => {
                    return this.listData = response.data.data.getErp;
                })
                .catch((error) => {
                    console.log(error)
                    return this.$vs.notify({
                        color: 'danger',
                        title: 'Erro',
                        text: 'Houve algum erro ao filtrar a pesquisa!'
                    });
                });
            },
            async sortFilter(sortValue) {
                if (sortValue === null) { return; }
                
                if (this.stateSort === undefined) {
                    this.stateSort = "ASC";
                } else if (this.stateSort === "ASC") {
                    this.stateSort = "DESC";
                } else {
                    this.stateSort = undefined;
                }

                if (this.stateSort !== undefined) {
                    await ERP.fetchWhere(this.search, sortValue, this.stateSort)
                    .then((response) => {
                        const parsedData = response.data.data.getErp;

                        return this.listData = parsedData
                        ;
                    })
                    .catch((error) => {
                        console.log(error)
                        return this.$vs.notify({
                            color: 'danger',
                            title: 'Erro',
                            text: 'Houve algum erro ao filtrar a pesquisa!'
                        });
                    });
                }
            },
            clearInstances() {
                this.instances          = [];
                this.instancesAvailable = [];
                this.instancesToRemove  = [];
                this.chooseConnections  = '';
            },
            async getErpInstance(erpId) {

                await ERP.fetchInstance(erpId)
                .then((response) => {
                    this.instances = response.data.data.erpInstances
                })
                .catch((error) => {
                    console.log(error)
                });
            },
            addInstances() {
                this.addInstancePopupActive = true
            },
            removeInstance (instance) {
                this.instancesToRemove.push(instance)
                this.instances.splice(this.instances.indexOf(instance), 1)
            },
            deleteInstances() {
                const removeInstances = [];
                for (let index = 0; index < this.instancesToRemove.length; index++) {
                    if (this.instancesToRemove[index].id) {
                        removeInstances.push(this.instancesToRemove[index].id); 
                    }
                }

                if (removeInstances.length > 0) {
                    ERP.removeErpInstances(removeInstances)
                    .then(() => {
                        this.getErpInstance(this.sidebarData.id)
                    })
                    .catch((error) => {
                        console.log(error)
                    });
                }
            },
            attachInstancesOnErp(selectedInstances) {
                this.addInstancePopupActive = false

                this.instances = [
                    ...this.instances,
                    ...selectedInstances
                ]
            }
        },
        watch: {
            currentPage() {
                this.previousNumberRegister = (this.currentPage * this.maxPerPage) - this.maxPerPage;
                this.nextNumberRegister = this.currentPage * this.maxPerPage;
            },
            maxPerPage() {
                this.totalPages = Math.ceil(this.registerLength/this.maxPerPage);

                this.previousNumberRegister = (this.currentPage * this.maxPerPage) - this.maxPerPage;
                this.nextNumberRegister = this.currentPage * this.maxPerPage;

                if (this.currentPage > this.totalPages) {
                    this.currentPage = this.totalPages;
                }
            },
            addInstancePopupActive: function (val) {
                if (val) {
                    const removeIds = this.instances.map(({ instance }) => instance.id)

                    this.$store.dispatch("user/fetchDiffInstances", removeIds).then(res => {
                    const { instances } = res.data.data
                    this.instancesAvailable = instances.map(instance => ({
                        id: null,
                        instance
                    }))
                    }).catch(err => {
                        console.error(err)
                    })
                }
            },
        },
        computed: {
            erpChoices() {
                const erpNames = []

                for (const erp of this.availableErps) {
                    erpNames.push({
                        text: erp.name,
                        value: erp.id
                    })
                }

                return erpNames
            },
        },
        mounted() {
            this.loadingData();
        },
        beforeRouteLeave(to, from, next) {
            if (this.sidebarIsActive) {
                this.sidebarIsActive = false;
                setTimeout( ()=> {
                next();
                }, 2);
            } 
            else if (this.modalDelete) {
                this.modalDelete = false;
                setTimeout( ()=> {
                next();
                }, 2);
            }
            else {
                next();
            }
        },
    }
</script>

<style>
    .select-fixes {
        background-color: #fff;
        border-radius: 9px;
    }

    #erproot * {
        margin: 0;
    }
    #erproot html {
        line-height: 1.5;
        letter-spacing: 0.02rem;
    }
    #erproot table.vs-table.vs-table--tbody-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        padding: 0 1rem;
    }
    #erproot tbody > tr {
        height: 5em;
        box-shadow: 0 4px 20px 0 rgb(0 0 0 / 5%);
    }
    #erproot thead > tr {
        background-color: transparent !important;
    }
    #erproot .vs-table-text {
        text-transform: uppercase;
        font-size: 12px;
    }
    #input-adjustment, input.input-select.vs-select--input {
        border-radius: 10px;
    }
    #erproot input.input-search.vs-table--search-input {
        height: 45px;
    }
    .input-select-con .v-select-erp .vs__dropdown-toggle {
        border-radius: 10px !important;
    } 
</style>

<style lang="scss" scoped>
    ::v-deep .vs-sidebar {
        z-index: 52010;
        width: 400px;
        max-width: 90vw;
    }
    ::v-deep .vs-sidebar--background {
        z-index: 52010;
    }

    .vs-select--item {
      color: #000;
      border-color: rgba(#000, 0.2);
      box-shadow: none;

      &:hover {
        background: #fff;
        // color: $grey;
      }
    }
</style>
